import template from './ukrail-cards.html';
import {emptyRailCard} from './ukrail-cards-service';

const DIRECTIVE_NAME = UkrailCards.DIRECTIVE_NAME = 'ktUkrailCards';
export default function UkrailCards() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: UkrailCardsController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            railCards: `=${DIRECTIVE_NAME}RailCards`,
            travellersCount: `=${DIRECTIVE_NAME}TravellersCount`,
            parentFormSubmitted: `=${DIRECTIVE_NAME}FormSubmitted`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function UkrailCardsController(
    $scope,
    ukrailCardsService
) {
    'ngInject';

    const vm = this;
    const defaultRailCardNumber = {value: 1, text: 1};
    const MAX_RAIL_CARDS_TYPES_COUNT = 3;
    const RAIL_CARD_ALREADY_SELECTED = 'railCardAlreadySelected';
    const INVALID_RAIL_CARD_COUNT = 'invalidRailCardCount';

    Object.assign(vm, {
        $onInit,
        placeholder: emptyRailCard,
        addRailCard,
        onRailCardCountChange,
        removeRailCard,
        isAddRailCardVisible,
        onRailCardsChange,
        onRailCardCheckboxSelect,
        invalidRailCardCount: false,
    });

    function $onInit() {
        vm.isRailCardsSelected = ukrailCardsService.railcardsApplied(vm.model.ukRailCards);
        vm.railCardsCountSelect = ukrailCardsService.initRailCardsCount();
        watchTravellerCountChange();
        watchParentFormSubmit();
    }

    function addRailCard() {
        vm.invalidRailCardCount = false;
        if (vm.travellersCount <= getTotalRailCardsCount()) {
            vm.invalidRailCardCount = true;
            return;
        }
        vm.model.ukRailCards.push(angular.copy(emptyRailCard));
        vm.model.ukRailCardNumbers.push(defaultRailCardNumber);
    }

    function setRailCardCountValidity(railCardField, isValid) {
        if (railCardField) {
            railCardField.$setValidity(INVALID_RAIL_CARD_COUNT, isValid);
        }
    }

    function onRailCardCountChange(index) {
        const idx = index || ukrailCardsService.getLastIndex(vm.model.ukRailCardNumbers);
        const isValid = vm.travellersCount >= getTotalRailCardsCount();
        vm.invalidRailCardCount = !isValid;
        const railCardField = vm.railCardsForm['railCardNumber' + idx];
        setRailCardCountValidity(railCardField, isValid);
    }

    function onRailCardsChange(index) {
        validateRailCardName(index);
    }

    function getTotalRailCardsCount() {
        return vm.model.ukRailCardNumbers.reduce((sum, item) => sum + item.value, 0);
    }

    function removeRailCard(index) {
        vm.model.ukRailCards.splice(index, 1);
        vm.model.ukRailCardNumbers.splice(index, 1);
        onRailCardCountChange();
    }

    function isAddRailCardVisible() {
        return vm.isRailCardsSelected
            && vm.model.ukRailCards.length < MAX_RAIL_CARDS_TYPES_COUNT
            && vm.travellersCount > getTotalRailCardsCount();
    }

    function getSelectedRailCardCodes() {
        const itemCode = (item) => item.Code;
        return vm.model.ukRailCards
            .filter(itemCode)
            .map(itemCode);
    }

    function watchTravellerCountChange() {
        $scope.$watch(() => vm.travellersCount, () => {
            onRailCardCountChange();
        });
    }
    function onRailCardCheckboxSelect() {
        vm.invalidRailCardCount = false;
        if (!vm.isRailCardsSelected) {
            vm.model.ukRailCards = [angular.copy(emptyRailCard)];
        }
    }

    function watchParentFormSubmit() {
        $scope.$watch(() => vm.parentFormSubmitted, () => {
            validateRailCardName();
        });
    }

    function validateRailCardName(index) {
        const idx = index || ukrailCardsService.getLastIndex(vm.model.ukRailCards);
        const cardCodes = getSelectedRailCardCodes();
        const hasDuplicates = ukrailCardsService.hasDuplicateRailCards(cardCodes);
        const railCardField = vm.railCardsForm['railCard' + idx];
        if (railCardField) {
            vm.railCardsForm['railCard' + idx].$setValidity(RAIL_CARD_ALREADY_SELECTED, !hasDuplicates);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/ukrail-cards/ukrail-cards-component.js